<script>
</script>

<main>
  <svg width="47" height="50" viewBox="0 0 47 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_dddd_5_824)">
      <rect x="6" y="1" width="40" height="40" rx="10" fill="url(#paint0_linear_5_824)" shape-rendering="crispEdges"/>
      <path d="M22.1074 20.858V16.5139C22.1074 16.2514 21.8948 16.0387 21.6323 16.0387H20.5628C19.5529 16.0387 18.6915 16.4842 18.0083 17.0486C17.4808 17.4844 15.8224 19.7261 14.9776 20.9055C14.92 20.9859 14.8894 21.0821 14.8894 21.181V25.4666C14.8894 25.736 15.1129 25.952 15.3823 25.9487C15.7067 25.9448 16.1214 25.9454 16.5231 25.9598C17.3548 25.9895 18.6024 25.6033 19.2261 24.6825C19.7024 23.9794 21.2087 22.1201 21.9993 21.1601C22.0695 21.0748 22.1074 20.9685 22.1074 20.858Z" fill="white"/>
      <circle cx="26.0009" cy="21.0005" r="3.0595" fill="white"/>
      <path d="M29.8926 20.858V16.5139C29.8926 16.2514 30.1052 16.0387 30.3677 16.0387H31.4372C32.4471 16.0387 33.3085 16.4842 33.9917 17.0486C34.5192 17.4844 36.1776 19.7261 37.0224 20.9055C37.08 20.9859 37.1106 21.0821 37.1106 21.181V25.4666C37.1106 25.736 36.8871 25.952 36.6177 25.9487C36.2933 25.9448 35.8786 25.9454 35.4769 25.9598C34.6452 25.9895 33.3976 25.6033 32.7739 24.6825C32.2976 23.9794 30.7913 22.1201 30.0007 21.1601C29.9305 21.0748 29.8926 20.9685 29.8926 20.858Z" fill="white"/>
    </g>
    <defs>
      <filter id="filter0_dddd_5_824" x="0.166667" y="0.166667" width="46.6667" height="49.1667" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset dx="-3.33333" dy="5.83333"/>
        <feGaussianBlur stdDeviation="1.25"/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0.0117647 0 0 0 0 0.0196078 0 0 0 0 0.0666667 0 0 0 0.02 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5_824"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset dx="-1.66667" dy="3.33333"/>
        <feGaussianBlur stdDeviation="1.25"/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0.0117647 0 0 0 0 0.0196078 0 0 0 0 0.0666667 0 0 0 0.08 0"/>
        <feBlend mode="normal" in2="effect1_dropShadow_5_824" result="effect2_dropShadow_5_824"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset dx="-0.833333" dy="1.66667"/>
        <feGaussianBlur stdDeviation="0.833333"/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0.0117647 0 0 0 0 0.0196078 0 0 0 0 0.0666667 0 0 0 0.14 0"/>
        <feBlend mode="normal" in2="effect2_dropShadow_5_824" result="effect3_dropShadow_5_824"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset/>
        <feGaussianBlur stdDeviation="0.416667"/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0.0117647 0 0 0 0 0.0196078 0 0 0 0 0.0666667 0 0 0 0.16 0"/>
        <feBlend mode="normal" in2="effect3_dropShadow_5_824" result="effect4_dropShadow_5_824"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect4_dropShadow_5_824" result="shape"/>
      </filter>
      <linearGradient id="paint0_linear_5_824" x1="26" y1="1" x2="26" y2="41" gradientUnits="userSpaceOnUse">
        <stop stop-color="#00ABFF"/>
        <stop offset="1" stop-color="#363BFF"/>
      </linearGradient>
    </defs>
  </svg>
</main>

<style>
</style>

  